<template>
  <div>
  <!-- <Header /> -->
  <div class="pricingplan-page">
    <v-btn style="background-color:#F19C0D; color:#ffffffcc; min-width:100px; font-size:16px" @click="backButton" v-if="is_first_time != 'yes'">Back</v-btn>
  <!-- <CommonHeader /> -->
  <div class="pricingplan-head">
    <h1>Choose your Subscription Plan</h1>

      <div class="free-trial-btn" v-if="is_first_time == 'yes'">
        <button class="btn trial-btn" style="cursor: default !important">Free Trial, Then Subscribe</button>
      </div>
      <div class="free-trial-btn" v-else-if="is_first_time == 'no' && plan_status == 'Free' && remaining_free_days <= 0">
        <button class="btn trial-btn" style="cursor: default !important">Free Trial has Ended</button>
      </div>
      <div class="free-trial-btn" v-else-if="is_first_time == 'no' && plan_status == 'PAID'">
        <button class="btn trial-btn" style="cursor: default !important">Subscription has Expired</button>
      </div>
     

    <p v-if="is_first_time == 'yes'">
      {{trial_days}} Days free trial then pay as per subscription plan you choose (Free Trial is applicable for initial subscription only).
    </p>
    <p>{{ showTitle }}</p>
    <!-- <p> to select one of your plans.</p> -->

      <v-card class="tab-card"
      >
        <v-tabs
          v-model="tab"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-2" class="tabs-box" >
              ANNUAL
          </v-tab>

        </v-tabs>

        <v-tabs-items v-model="tab" class="tabs-content">
      
          <v-tab-item
            value="tab-2"
          >
            <Annual @change-selection="testing" @eventname="updateparent" @eventPlanStatus="planStatus" @remainingDays="remainingDays" @trialDays="trialDays"/>
          </v-tab-item>
        </v-tabs-items>
        
      </v-card>
  </div>
  </div>
</div>
</template>

<script>
import Header from "../common/Header.vue";
import CommonHeader from "./CommonHeader.vue";
import Annual from "./Annual.vue";
import Monthly from "./Monthly.vue";
import axios from "axios";
import {
  CREATE_DEFAULT_SUBSCRIPTION,
  UPDATE_PROFILE_DETAIL,
} from "../../store/actions.type";
export default {
  components: {
    Header,
    CommonHeader,
    Monthly,
    Annual,
  },
  data() {
    return {
      tab: null,
      text: "text1",
      tabName: "annual",
      showTitle:
        "Gold plan is ideal if you intend to use for your self and your family.",
      is_first_time: "",
      plan_status: "",
      remaining_free_days: "",
      trial_days: ""
    };
  },
  created() {},
  methods: {
    backButton(){
      this.$router.push({ name: "dashboard"}).catch(()=>{});
    },
    testing(val) {
      this.showTitle = val;
    },
    CheckTab(tabName) {
      this.tabName = tabName;
    },
    chooseDefaultPlan() {
      this.$loading(true);
      this.$store
        .dispatch(CREATE_DEFAULT_SUBSCRIPTION, {
          data: {
            name: this.$store.getters.getUserDetails.user_name,
            email: this.$store.getters.getUserDetails.email,
            mobile_no: this.$store.getters.getUserDetails.mobile_no,
            aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
          },
          api: "create-default-subscription",
        })
        .then(() => {
          this.$loading(false);
          let updatedDetail = [
            {
              key: "is_plan_active",
              value:
                this.$store.getters.getDefaultSubscription.data.is_plan_active,
            },
            {
              key: "subscription_plans",
              value:
                this.$store.getters.getDefaultSubscription.data
                  .subscription_plans,
            },
          ];
          this.$store.dispatch(UPDATE_PROFILE_DETAIL, updatedDetail);
          this.$router.push({
            name: "SubscriptionCongratulations",
            params: { is_default_plan: true },
          });
        })
        .catch((error) => {
          this.$loading(false);
        });
    },
    updateparent(variable) {
      this.is_first_time = variable;
    },
    planStatus(variable) {
      this.plan_status = variable;
    },
    remainingDays(variable) {
      this.remaining_free_days = variable;
    },
    trialDays(variable) {
      this.trial_days = variable;
    }
  },
};
</script>